var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9472 5.82314C14.7499 8.47938 12.7331 10.6463 10.519 10.6463C8.30494 10.6463 6.28459 8.47989 6.09085 5.82314C5.88957 3.05988 7.85206 1 10.519 1C13.186 1 15.1485 3.11012 14.9472 5.82314Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.646 13.6934C6.27523 13.6934 1.83911 16.1303 1.01821 20.7301C0.919237 21.2845 1.22971 21.8165 1.80395 21.8165H19.4881C20.0628 21.8165 20.3733 21.2845 20.2744 20.7301C19.4529 16.1303 15.0168 13.6934 10.646 13.6934Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.1aa92f76a2698e8fdfe2384de054dbfa.svg";
export { ForwardRef as ReactComponent };